class LoginController {
  constructor($scope, $state, $stateParams, $translate, authenticationService, pageLoaderService, userAccountService, formValidationService, $location) {
    this.$scope = $scope;
    this.$state = $state;
    this.$translate = $translate;
    this.$location = $location;
    this.authenticationService = authenticationService;
    this.pageLoaderService = pageLoaderService;
    this.userAccountService = userAccountService;
    this.EMAIL_REGEX = formValidationService.EMAIL_REGEX;
    this.invalidEmail = false;
    this.hideTimeoutMessage = false;

    if($stateParams.passwordUpdated) {
      this.success = true;
    }

    var userLoggedIn = this.authenticationService.hasToken() && !this.authenticationService.isTokenExpired();
    if (userLoggedIn) {
      this.redirect('home.dashboard');
      return;
    }
  }

  redirect(newState,tabName) {
    this.$state.go(newState,{tabName});
  }

  isTimeout() {
    return !!this.$state.current.isTimeout && !this.hideTimeoutMessage;
  }

  login() {
    if (!this.$scope.form.$valid) {
      return;
    }

    if (this.error) {
      this.error = null;
    }

    this.pageLoaderService.show();
    this.authenticationService.login(this.email, this.password).then(
      this.onAuthSuccess.bind(this),
      this.onAuthFailed.bind(this)
    );
  }

  validateEmail() {
    this.invalidEmail = !this.$scope.form.email.$valid;
  }

  removeMessages() {
    this.invalidEmail = false;
    this.error = false;
    this.$scope.form.$submitted = false;
    this.hideTimeoutMessage = true;
    this.success = false;
  }

  showError() {
    let form = this.$scope.form;

    return (form.$submitted && !form.$valid) || this.invalidEmail;
  }

  onAuthSuccess() {
    this.userAccountService.getUserDetails().then(
      this.onUserDetailsRetrievalSuccess.bind(this),
      this.onUserDetailsRetrievalFailure.bind(this)
    );
  }

  onAuthFailed(authResponse) {
    if(authResponse.status === 401) {
      this.setError('LOGIN_FAILED');
    } else if(authResponse.status === 406) {
      this.redirectToPasswordReset(authResponse.data.passwordResetLink);
    } else {
      this.setError('UNKNOWN_ERROR');
    }

    this.pageLoaderService.hide();
  }

  redirectToPasswordReset(passwordResetLink) {
    passwordResetLink = passwordResetLink + '&expireMessage=true';

    this.$location.url(passwordResetLink);
  }

  onUserDetailsRetrievalSuccess() {
    this.pageLoaderService.hide();
    let defaultState = 'dashboard';
    let redirectState = this.$location.search().redirect && this.$location.search().redirect.split('/');
    let stateName = redirectState && redirectState[1];
    let tabName = redirectState && redirectState[2];
    
    let newState = stateName ? `home.${stateName}` : `home.${defaultState}`;

    this.redirect(newState,tabName);
  }

  onUserDetailsRetrievalFailure() {
    this.pageLoaderService.hide();
    this.setError('UNKNOWN_ERROR');
  }

  setError(error) {
    this.$translate(error).then(this.onErrorTranslated.bind(this));
  }

  onErrorTranslated(translation) {
    this.error = translation;
  }
}

LoginController.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  '$translate',
  'AuthenticationService',
  'pageLoaderService',
  'userAccountService',
  'formValidationService',
  '$location'
];

export
default LoginController;



// WEBPACK FOOTER //
// ./app/components/login/login.controller.js